import * as React from 'react';
import * as ReactDOM from 'react-dom';

export class AppModal extends React.Component {
    static rootNode: HTMLDivElement;

    static setRootNode(node: HTMLDivElement) {
        AppModal.rootNode = node;
    }

    render() {
        if (!AppModal.rootNode) {
            return null;
        }

        return ReactDOM.createPortal(this.props.children, AppModal.rootNode);
    }
}
